import { get } from '../utils/api';

class StateService {
  getAll(options?: Object) {
    return get('/states', options);
  }
}

export default StateService;
